import PagesVisitorManagementVisitorComponentsVisitorApprovalHodGrid from "libs/pages/visitor-management/visitor-components/hod-approval/src/lib/pages-visitor-management-visitor-components-hod-approval";
import RequestForm from "libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/pages-visitor-management-visitor-components-visitor-request-form"
import VisitorCard from "libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/visitor-card";
import VisitorDetailedView from "libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/visitor-detailed-view";
import { PagesVisitorManagementVisitorComponentsVisitorApprovalHRGrid } from 'libs/pages/visitor-management/visitor-components/hr-approval/src/lib/pages-visitor-management-visitor-components-hr-approval';
import React from "react"
import { PagesVisitorManagementVisitorComponentsSecurityPanelGrid } from 'libs/pages/visitor-management/visitor-components/security-panel/src/lib/pages-visitor-management-visitor-components-security-panel';
import { VisitorStatusReport } from 'libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/visitor-statusreport';
import { VisitorDashboard } from 'libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/dashboard';
import { Route, useLocation, useParams } from "react-router-dom"

export const VmsRouting = () => {
    const { id } = useParams<any>();
    console.log(id);
    const location = useLocation()
    location.pathname
    console.log(location)
    if (location.hash.includes('visitor-card')) {
        const loc = location.hash.split('/');
        const visitorId = Number(loc[2]);
        return <VisitorCard id={visitorId}></VisitorCard>
    }
    if (location.hash.includes('request-form')) {
        return <RequestForm></RequestForm>
    }
    console.log(location, '##')
    if (location.pathname.includes('detailed-view')) {
        console.log(location, '##')
        return <VisitorDetailedView></VisitorDetailedView>
    }
    if (location.hash.includes('visitor-statusreport')) {
        const loc = location.hash.split('/');
        const visitorId = Number(loc[2]);
        return <VisitorStatusReport id={visitorId}></VisitorStatusReport>
    }
    return (
        <>
            <Route exact path='/request-form' component={RequestForm} />
            <Route exact path='/hod-approval' component={PagesVisitorManagementVisitorComponentsVisitorApprovalHodGrid} />
            <Route exact path='/hr-approval' component={PagesVisitorManagementVisitorComponentsVisitorApprovalHRGrid} />
            <Route exact path='/security-panel' component={PagesVisitorManagementVisitorComponentsSecurityPanelGrid} />
            <Route exact path='/visitor-card/:id' component={VisitorCard} />
            <Route exact path='/visitor-statusreport' component={VisitorStatusReport} />
            <Route exact path='/visitor-dashboard' component={VisitorDashboard} />

        </>
    )
}
export default VmsRouting;